import { render, staticRenderFns } from "./Brochure.vue?vue&type=template&id=067a55d7"
import script from "./Brochure.vue?vue&type=script&lang=js"
export * from "./Brochure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports